angular.module('directives.authentication')
    .directive('registrationForm', ['configs', '$state', 'Authentication', 'PortalApi', 'Notification', '$interval', 'Localization', directive]);

function directive(configs, $state, Authentication, PortalApi, Notification, $interval, Localization) {

    return {
        restrict: 'A',
        template: require('../templates/registrationForm.html'),
        link: postLink
    };

    function postLink($scope, el, attr, controller) {
        $scope.registrationStep = '';

        $scope.changeStep = function(activeStep) {
            $scope.registrationStep = activeStep;
        };

        $scope.init = function(activeStep) {
            $scope.registrationStep = 'registration';
        };

        $scope.regForm = {
            login: '',
            password: '',
            email: '',
            phone: '',
            name: ''
        };

        $scope.toStepTwo = function(form) {
            $scope.regForm.login = form.login;
            $scope.regForm.name = form.name;
            $scope.regForm.password = form.password;
            $scope.regForm.email = form.email;
            $scope.regForm.phone = '380' + String(form.phone).replace(/[^\d]/g, '');
            $scope.came = 300;
            $scope.avail = false;
            $scope.time = {};



            $scope.time.s = "00";
            $scope.time.m = "5";

            var tick = function() {



                if ($scope.came == 0) {
                    $interval.cancel($scope.timer);
                    $scope.avail = true;
                }
                $scope.came--;


                $scope.time.s = ($scope.came % 60) < 10 ? "0" + $scope.came % 60 : $scope.came % 60
                $scope.time.m = Math.floor($scope.came / 60);
            }
            $scope.timer = $interval($scope.tick, 1000);


            var value = form.phone.substr(0, 2);
            var config = configs.mobile_codes;
            for (var i = 0; i < config.length; ++i) {
                if (config[i].codes.indexOf(value) != -1) {
                    $scope.sendSmsCode(true);
                    return;
                }
            }
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.MOBILE_OPERATOR_E', 5, true);
        };

        $scope.sendSmsCode = function(changeStep) {
            if ($scope.avail) {
                $scope.came = 300;
                $scope.timer = $interval($scope.tick, 1000);
                $scope.avail = false;
                $scope.time.s = "00";
                $scope.time.m = "5";
            }

            $scope.activeSliderFormPreLoader(true);

            PortalApi.registrySendSms($scope.regForm.phone).then(function(response) {

                if (changeStep) {
                    $scope.changeStep('verifyPhone');
                }else{
                    return $translate('REG.CONTIN.SMS_1').then(function(transform1) {
                        return $translate('REG.CONTIN.SMS_2').then(function(transform2) {
                            return Notification.success({
                                message: transform1 + $scope.regForm.phone + transform2,
                                delay: 5000
                            });
                        });
                    });
                }
            }, function() {

                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.SMS_SEND_E', 5, true);

            }).finally(function() {
                $scope.activeSliderFormPreLoader();
            });
        };

        $scope.verifySmsCode = function(form) {

            $scope.activeSliderFormPreLoader(true);

            PortalApi.registryVerifySmsCode({
                phone: $scope.regForm.phone,
                code: form.code
            }).then(function(response) {

                if (response.status !== 'ok') {

                    $scope.activeSliderFormPreLoader();

                    Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.WRONG_CODE', 5, true);
                }

                $scope.registration();

            }, function() {
                $scope.activeSliderFormPreLoader();
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.WRONG_CODE', 5, true);
            })
        };

        $scope.registration = function() {

            $scope.activeSliderFormPreLoader(true);

            PortalApi.userRegistry($scope.regForm).then(
                function(response) {

                    if (response.status !== 'ok') {

                        $scope.activeSliderFormPreLoader();
                        Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.USER_MAIL_LOGIN_EXIST', 5, true);

                    }else{
                        Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.REG_DONE', 5, true);
                    }

                    $scope.toggleSliderForm('', true);
                },
                function() {
                    Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.REG_E_REPEAT', 5, true);
                }
            ).finally(function() {
                $scope.activeSliderFormPreLoader();
            });
        };

        $scope.init();
    }
}

module.exports = 'directives.registration';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/authentication/directives/registration.directive.js
 ** module id = 126
 ** module chunks = 1
 **/